import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import { addDays, format, parseISO } from 'date-fns';
import { queryExamine, queryCate } from '@/api/reimburse/reimburseApi.js';
export default {
  data: function data() {
    var columns = [{
      title: '报销编号',
      dataIndex: 'fillId',
      align: 'center',
      width: 80
    }, {
      title: '报销名称',
      dataIndex: 'fillName',
      align: 'center',
      ellipsis: true,
      width: 150
    }, {
      title: '报销金额',
      dataIndex: 'totalAmount',
      align: 'center',
      width: 90
    }, {
      title: '申请人',
      dataIndex: 'userName',
      align: 'center',
      width: 120,
      ellipsis: true,
      customRender: function customRender(userName, row) {
        return userName + ' (' + row.organName + '/' + row.postName + ')';
      }
    }, {
      title: '申请时间',
      dataIndex: 'createTime',
      align: 'center',
      width: 120
    }, {
      title: '当前环节',
      dataIndex: 'appendName',
      align: 'center',
      width: 120
    }, {
      title: '审核状态',
      dataIndex: 'auditStatus',
      align: 'center',
      width: 80,
      scopedSlots: {
        customRender: 'auditStatus'
      }
    }, {
      title: '审核时间',
      dataIndex: 'auditDate',
      align: 'center',
      width: 100
    }, {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      width: 100,
      scopedSlots: {
        customRender: 'action'
      }
    }];
    return {
      columns: columns,
      loading: false,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      expand: false,
      where: {
        auditStatus: undefined,
        cateId: undefined,
        startAndEndDate: [],
        title: '',
        startDate: '',
        endDate: '',
        query: ''
      },
      data: [],
      pagination: this.$hdk.page(),
      visibleMode: false,
      cateList: []
    };
  },
  created: function created() {
    var _this = this;
    var fetch = this.fetch;
    fetch();
    // 查询报销分类
    queryCate().then(function (res) {
      _this.cateList = res.data.data;
    });
  },
  methods: {
    /*
     * 根据条件搜索
     */
    fetch: function fetch(options) {
      var _this2 = this;
      var pagination = this.pagination,
        where = this.where,
        pager = _.assign({}, pagination, options);
      this.loading = true;
      if (!pager.where) {
        pager.where = where;
      }

      // 日期格式化
      if (where.startAndEndDate.length > 0) {
        this.where.startDate = parseISO(format(where.startAndEndDate[0]._d, 'yyyy-MM-dd'));
        this.where.endDate = parseISO(format(where.startAndEndDate[1]._d, 'yyyy-MM-dd'));
      } else {
        this.where.startDate = null;
        this.where.endDate = null;
      }
      queryExamine(pager.current, pager.pageSize, pager.where).then(function (res) {
        _this2.data = res.data.data;
        _.assign(pagination, {
          total: res.data.count,
          current: pager.current,
          pageSize: pager.pageSize
        });
        _.assign(where, pager.where);
      }).finally(function () {
        _this2.loading = false;
      });
    },
    /*
     * 审核
     */
    auditApproval: function auditApproval(row) {
      if (row.cateId === 1) {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/travelApproval',
          query: {
            fillId: row.fillId,
            type: 2
          }
        });
      } else if (row.cateId === 2) {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/expenseApproval',
          query: {
            fillId: row.fillId,
            type: 2
          }
        });
      }
    },
    /*
     * 查看
     */
    viewApproval: function viewApproval(row) {
      if (row.cateId === 1) {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/travelApproval',
          query: {
            fillId: row.fillId,
            type: 1
          }
        });
      } else if (row.cateId === 2) {
        this.$router.push({
          path: '/reimburseRepairs/myReimburse/expenseApproval',
          query: {
            fillId: row.fillId,
            type: 1
          }
        });
      }
    },
    /*
     * 表格改变事件
     */
    onChange: function onChange(pagination) {
      this.fetch({
        current: pagination.current,
        pageSize: pagination.pageSize,
        where: this.where
      });
    },
    /*
     * 是否打开折叠搜索界面
     */
    toggle: function toggle() {
      this.expand = !this.expand;
    }
  }
};